import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';

import { Option } from 'apis/restaurant-api/merchant-admin/menu2/types';
import { MenuLocaleContext } from 'modules/menu/MenuLocaleContext';
import { MenuMetaContext } from 'modules/menu/MenuMetaContext';
import useBulkSelection from 'modules/menu/bulk-actions/useBulkSelection';
import OptionModal from 'modules/menu/options/components/OptionModal';
import useMenuData from 'modules/menu/useMenuData';

import OptionBindingsModal from '../OptionBinding/OptionBindingsModal';

type Props = {
  isOpen: boolean;
  loading?: boolean;
  onClose: () => void;
  onAddOptionBindings: (selectedOptionIds: Set<string>) => void;
};

const AddOptionsToItem = ({ isOpen, loading, onClose, onAddOptionBindings }: Props) => {
  const intl = useIntl();

  const [isOptionModalOpen, setIsOptionModalOpen] = useState(false);

  const { country, primaryLanguage } = useContext(MenuLocaleContext);
  const { menuId } = useContext(MenuMetaContext);

  const { updateMenuData } = useMenuData();

  const {
    selectedIds: selectedOptionIds,
    select: selectOption,
    deselect: deselectOption,
    clearSelection: clearOptionSelection,
  } = useBulkSelection();

  const handleDone = () => {
    onAddOptionBindings(selectedOptionIds);
    clearOptionSelection();
  };

  const handleOptionCreated = (option: Option) => {
    updateMenuData({ actionType: 'addOption', payload: option });
    selectOption(option.id);
  };

  const handleClose = () => {
    onClose();
    clearOptionSelection();
  };

  return (
    <>
      <OptionBindingsModal
        loading={loading}
        mode="singleItem"
        onClose={handleClose}
        onCreateOption={() => setIsOptionModalOpen(true)}
        onDeselectOption={deselectOption}
        onSelectOption={selectOption}
        isOpen={isOpen}
        onDone={handleDone}
        selectedOptionIds={selectedOptionIds}
        title={intl.formatMessage({ id: 'menu-item.addOptionsHeader' })}
      />
      <OptionModal
        country={country}
        menuId={menuId}
        onOptionCreated={handleOptionCreated}
        primaryLanguage={primaryLanguage}
        isOpen={isOptionModalOpen}
        onClose={() => setIsOptionModalOpen(false)}
      />
    </>
  );
};

export default AddOptionsToItem;
